import { JetView } from 'webix-jet';
import {
    devConfig,
    countries,
    providersCasino,
    subprovidersCasino,
    gamesCasino,
    profile,
    machines,
} from 'config/config';

/**
 * Class representing the FilterMachineProductsView.
 * @extends JetView
 */
export default class FilterMachineProductsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const screen = this.app.config.size; // Get the current screen size
        const cur_user = this.getParam('user', true); // Retrieve the current user parameter

        // Left section containing provider and machine selection
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'combo',
                            name: 'ProviderId', // Combo for selecting provider
                            localId: 'provider:combo',
                            label: _('Proveedor'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this; // Reference to the current context
                                        if (text.length > 2) {
                                            // Trigger data fetch if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/ProvidersCasinoSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Show error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (
                                                                !resp.HasError // Check for errors in response
                                                            ) {
                                                                vthis.parse(
                                                                    resp.Data, // Parse and display data
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo',
                            name: 'SubProviderId', // Combo for selecting sub-provider
                            localId: 'subProvider:combo',
                            label: _('Sub Proveedor'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this; // Reference to the current context
                                        if (text.length > 2) {
                                            // Trigger data fetch if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/SubProvidersCasinoSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Show error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (
                                                                !resp.HasError // Check for errors in response
                                                            ) {
                                                                vthis.parse(
                                                                    resp.Data, // Parse and display data
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                        {
                            view: 'combo',
                            name: 'MachineReference', // Combo for selecting machine reference
                            label: _('Máquina Referencia'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: {
                                body: {
                                    dataFeed: function (text) {
                                        var vthis = this; // Reference to the current context
                                        if (text.length > 2) {
                                            // Trigger data fetch if input length is greater than 2
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'es/Select/MachinesSelect',
                                                    '{"Filter":"' + text + '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            webix.message(
                                                                'Error! ', // Show error message on failure
                                                            );
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            var resp = JSON.parse(text);
                                                            if (
                                                                !resp.HasError // Check for errors in response
                                                            ) {
                                                                vthis.parse(
                                                                    resp.Data, // Parse and display data
                                                                );
                                                            }
                                                        },
                                                    },
                                                );
                                        }
                                    },
                                },
                            },
                        },
                    ],
                },
            ],
        };

        // Left section containing filters and limits
        const left2 = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect',
                            name: 'IsVerified', // Rich select for verification status
                            label: "<span class='icon-verified_user'></span>" + _('Verificado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                        {
                            view: 'richselect',
                            name: 'FilterCountry', // Rich select for country filter
                            label: "<span class='icon-language'></span>" + _('Filtro País'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: [
                                { id: 'null', value: _('Todos') },
                                { id: 'A', value: _('Activado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                        },
                        {
                            view: 'text',
                            name: 'Maximum', // Text input for maximum value
                            type: 'number',
                            label: _('Máximo'),
                            labelPosition: 'top',
                            placeholder: _('Máximo'),
                            invalidMessage: _('Máximo is required'), // Validation message
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text',
                            name: 'Minimum', // Text input for minimum value
                            type: 'number',
                            label: _('Mínimo'),
                            labelPosition: 'top',
                            placeholder: _('Mínimo'),
                            invalidMessage: _('Mínimo is required'), // Validation message
                        },
                        {
                            view: 'text',
                            name: 'ProcessingTime', // Text input for processing time
                            type: 'number',
                            label: "<span class='icon-history'></span>" + _('Tiempo Procesamiento'),
                            labelPosition: 'top',
                            placeholder: _('Tiempo Procesamiento'),
                            invalidMessage: _(
                                'Tiempo Procesamiento is required', // Validation message
                            ),
                        },
                        { id: 'grav2', gravity: 1 }, // Gravity for layout
                    ],
                },
            ],
        };

        // Upper section containing the left filters
        const upper_section = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 250 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left], // Include left section
                },
            ],
        };

        // Upper section containing additional filters
        const upper_section2 = {
            css: 'father-container',
            height: document.body.offsetWidth < 500 ? 320 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left2], // Include left2 section
                },
            ],
        };

        // Accordion section for advanced filters
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'), // Header for advanced filters
                            body: {
                                padding: 10,
                                rows: [upper_section2], // Include upper_section2
                            },
                        },
                    ],
                },
            ],
        };

        // Button section for actions
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout
                        {
                            view: 'button',
                            value: _('Limpiar'), // Clear button
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clear the form
                            },
                        },
                        {
                            view: 'button',
                            value: _('Consultar'), // Consult button
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get form values
                                filterdata.IdMachine = cur_user; // Add current user to filter data
                                this.app.callEvent(
                                    'machineSubProvider:filter',
                                    [filterdata], // Trigger filter event with data
                                );
                                $$('b1').collapse(); // Collapse the filter section
                                $$('a5').scrollTo(100, 0); // Scroll to a specific position
                            },
                        },
                    ],
                },
            ],
        };

        // Accordion section for main filters
        const accordion_section1 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for main filters
                            id: 'b1',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper_section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Return the main form configuration
        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section1], // Include accordion_section1
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view after it is rendered.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                $$('grav').hide(); // Hide element if screen width is less than 500
            }
        });
    }
}

// FILE DOCUMENTED
